import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { Company, CompanyCreate, CompanyFilter } from '../data/company';

export function createCompanyService(client: AxiosInstance) {
  return createCrudService<Company, CompanyCreate, CompanyFilter>(client, '/Company', 'companyId');
}

export type CompanyService = CrudService<Company, CompanyCreate, CompanyFilter>;
